<template>
  <div class="page-form ">
    <h3 class="title">停发货设置</h3>
    <affix>
      <div class="tools">
        <form-button name="提交" icon="form-advance" @click="saveData" />
        <form-button name="返回" icon="form-advance" @click="$emit('change-mode', 'query')" />
      </div>
    </affix>

    <div class="table-container form-container">
      <el-form inline class="form" size="mini" label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="批导类型" label-width="80">
              <el-select
                v-model="conditions.templateCode"
                placeholder="请选择"
                type="select"
                clearable
                @change="conditionChanged"
              >
                <el-option
                  v-for="item in selectTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="16" class="download">
            <el-dropdown @command="downloadTemplate">
              <div class="tempDownload">
                <img src="@/assets/images/excel@3x.png" alt="">
                <span class="el-dropdown-link">
                  模版下载
                </span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{
                    type: 'stopDeliverySale',
                    fileName: '战区导入模板下载_V1.0'
                  }"
                >战区导入模板下载</el-dropdown-item>
                <el-dropdown-item
                  :command="{
                    type: 'stopDeliveryBase',
                    fileName: '基地导入模板下载_V1.0'
                  }"
                >基地导入模板下载</el-dropdown-item>
                <el-dropdown-item
                  :command="{
                    type: 'stopDeliveryDealer',
                    fileName: '经销商导入模板下载_V1.0'
                  }"
                >经销商导入模板下载</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col> -->

        </el-row>
      </el-form>

      <TableCommon title="明细" :custome-config="() => vxeShowCustom('xTable')">
        <template #button>
          <table-button tip="新增" name="add" @click="addRow" />
          <table-button tip="批导" name="import" @click="handleImportExcel" />
          <table-button tip="模版下载" name="download" @click="downloadTemplate" />
          <table-button tip="删除" name="delete" @click="delRow" />
          <table-button tip="确认导入" name="confirm" @click="handleSaveImportExcel" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
            <el-select
              v-if="item.field === 'stopRange'"
              :key="item.field"
              v-model="row.stopRange"
              disabled
              size="mini"
            >
              <el-option
                v-for="item2 in stopOptions"
                :key="item2.value"
                :value="item2.value"
                :label="item2.name"
              />
            </el-select>
            <span v-else :key="item.field">{{ row[item.field] }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <el-dialog v-dialogDrag :visible.sync="showDialog" :title="dialogTitle" width="70%">
      <client-select v-if="dialogTitle === '客户选择'" ref="dialogSelect" :is-radio="false" />
      <org-select v-if="dialogTitle === '营销中心'" ref="dialogSelect" />
      <div slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle">确定</el-button>
      </div>
    </el-dialog>

    <!-- 页面通用弹窗情况 -->
    <el-dialog
      title="停发货设置新增"
      :visible.sync="showPageEditDialog"
      fullscreen
      :before-close="beforeClose"
      :append-to-body="true"
    >
      <delivery-settings-edit v-if="showPageEditDialog" :mode="mode" @close="closePageEditDialog" />
    </el-dialog>
  </div>
</template>

<script>
import {
  apiCityArea,
  apiExcelImport,
  apiGetExcelImportData,
  apiSaveExcelImportData,
  apiExportExcelTemplate
} from '@/api/common'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiAddStopDelivery } from '@/api/applyForGoods/stopAndSend'
import ClientSelect from '../../../../components/dialog/ClientSelect.vue'
import OrgSelect from '../../../../components/dialog/OrgSelect.vue'

import DeliverySettingsEdit from './DeliverySettingsEdit.vue'

export default {
  components: {
    ClientSelect,
    OrgSelect,
    DeliverySettingsEdit
  },
  data() {
    return {
      showDialog: false,
      showPageEditDialog: false,
      mode: 'add',
      dialogTitle: '',
      currentRow: {},
      conditions: {
        templateCode: 'stopDeliverySale',
        batchNumber: ''
      },
      selectDataOptions: {},
      deliveryAddSourceData: {},
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkebox', width: 50 },
          { title: '停货范围', field: 'stopRange', width: 180, slots: { default: 'stopRange' }},
          {
            title: '营销中心',
            field: 'saleCenterName',
            width: 180,
            slots: { default: 'saleCenterName' }
          },
          { title: '基地', field: 'baseName', width: 180, slots: { default: 'baseName' }},
          { title: '经销商', field: 'dealerName', width: 240, slots: { default: 'dealerName' }},
          { title: '存货分类', field: 'brandName', width: 240, slots: { default: 'brandName' }},
          { title: '渠道', field: 'planTypeName', width: 240, slots: { default: 'planTypeName' }},
          {
            title: '生效开始日期',
            field: 'effectiveStartDate',
            width: 180,
            slots: { default: 'effectiveStartDate' }
          },
          {
            title: '生效截止日期',
            field: 'effectiveEndDate',
            width: 180,
            slots: { default: 'effectiveEndDate' }
          },
          // { title: '状态', field: 'status', width: 180 },
          // { title: '申请人', field: 'createdByName', width: 180 },
          { title: '停发货原因', field: 'stopReason', width: 180, slots: { default: 'stopReason' }}
        ],
        data: []
      },
      stopOptions: [
        {
          name: '战区',
          value: 'war'
        },
        {
          name: '基地',
          value: 'area'
        },
        {
          name: '经销商',
          value: 'dealer'
        }
      ],
      selectTypes: [
        {
          id: 'stopDeliverySale',
          name: '战区导入模板'
        },
        {
          id: 'stopDeliveryBase',
          name: '基地导入模板'
        },
        {
          id: 'stopDeliveryDealer',
          name: '经销商导入模板'
        }
      ]
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0019')
    this.getSelectDictDataOrigin('A0002')
    // 渠道类型
    this.getSelectDictDataOrigin('A0054')
    this.getSelectDictDataOrigin('stopDeliveryRange')
    apiCityArea({ parentId: 0 }).then(({ data }) => {
      this.selectDataOptions.regionList = data.Rows
    })
  },
  methods: {
    // 模板下崽
    async downloadTemplate() {
      const res = await apiExportExcelTemplate(this.conditions.templateCode)

      if (res?.status !== 0) {
        return
      }
      const fileName = this.selectTypes.find(item => item.id === this.conditions.templateCode).name

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${fileName}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    async saveData() {
      const params = JSON.parse(JSON.stringify(this.gridOptions.data))

      const { status } = await apiAddStopDelivery(params)
      if (status === 1) {
        this.$message.success('提交成功')
        this.$emit('change-mode', 'query')
      }
    },
    addRow() {
      this.showPageEditDialog = true
      // const row = {}
      // this.gridOptions.columns.filter(v => !v.type).forEach(col => {
      //   row[col.field] = ''
      // })
      // row.status = 0
      // row.dealerName = []
      // row.dealerCode = []
      // this.gridOptions.data.unshift(row)
    },
    delRow() {
      const data = this.$refs.xTable.getCheckboxRecords()
      if (data && data.length > 0) {
        data.forEach(row => {
          const index = this.gridOptions.data.findIndex(v => v._X_ID === row._X_ID)
          this.gridOptions.data.splice(index, 1)
        })
      }
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (data) {
        if (this.dialogTitle === '客户选择') {
          this.currentRow.dealerName = data.map(v => v.name_org1)
          this.currentRow.dealerCode = data.map(v => v.partner)
          // this.currentRow.dealerName = [...new Set(this.currentRow.dealerName.concat(data.map(v => v.name_org1)))]
          // this.currentRow.dealerCode = [...new Set(this.currentRow.dealerCode.concat(data.map(v => v.partner)))]
          this.currentRow.customerName = this.currentRow.dealerName.join(',')
        } else {
          this.currentRow.saleCenter = data.code
          this.currentRow.saleCenterName = data.name
        }
      }
      this.showDialog = false
    },
    openDialog(e, title, row) {
      e.target.blur()
      this.dialogTitle = title
      this.currentRow = row
      this.showDialog = true
    },
    conditionChanged(value) {},
    // 导入excel
    async handleImportExcel() {
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: this.conditions.templateCode
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.conditions.batchNumber = res.data
            this.handleQueryImportExcel(res.data)
          }
        })
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      const params = { ...this.conditions, page: 1, pagesize: 1000 }
      const res = await apiGetExcelImportData(params)
      this.gridOptions.data = res.data.Rows
    },
    // 将导入临时表的数据保存到正式业务表
    async handleSaveImportExcel() {
      const formData = new FormData()
      const { batchNumber, templateCode } = this.conditions
      formData.append('batchNumber', batchNumber)
      formData.append('templateCode', templateCode)
      const res = await apiSaveExcelImportData(formData)
      if (res.status === 1) {
        this.$message.success('保存成功!')
      }
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this.selectDataOptions, dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 弹窗关闭前操作
    beforeClose(done) {
      done()
    },
    closePageEditDialog(conditions) {
      this.showPageEditDialog = false
      this.deliveryAddSourceData = conditions
      const gridData = this.formatToTableData(conditions)
      this.gridOptions.data = gridData
    },
    formatToTableData(conditions) {
      console.log('formatToTableData', conditions)
      const gridData = []
      const stopDeliveryList = {
        stopRange: '',
        saleCenterName: '',
        saleCenter: '',
        base: '',
        baseName: '',
        dealerName: '',
        dealerCode: '',
        brand: '',
        brandName: '',
        planType: '',
        planTypeName: '',
        effectiveStartDate: '',
        effectiveEndDate: '',
        stopReason: ''
      }
      const {
        stopRange,
        saleCenter,
        base,
        dealer,
        brand,
        planType,
        effectiveStartDate,
        effectiveEndDate,
        stopReason
      } = conditions
      stopDeliveryList.stopRange = stopRange
      stopDeliveryList.effectiveStartDate = effectiveStartDate
      stopDeliveryList.effectiveEndDate = effectiveEndDate
      stopDeliveryList.stopReason = stopReason

      if (stopRange === 'war') {
        saleCenter.forEach(item => {
          const obj = { ...stopDeliveryList }
          obj.saleCenterName = item.deptName
          obj.saleCenter = item.deptCode

          if (planType.length) {
            planType.forEach(item2 => {
              const obj2 = { ...obj }
              obj2.planType = item2.value
              obj2.planTypeName = item2.name

              if (brand.length) {
                brand.forEach(item3 => {
                  const obj3 = { ...obj2 }
                  obj3.brandName = item3.name
                  obj3.brand = item3.value
                  gridData.push(obj3)
                })
              } else {
                gridData.push(obj2)
              }
            })
          } else {
            brand.forEach(item3 => {
              const obj3 = { ...obj }
              obj3.brandName = item3.name
              obj3.brand = item3.value
              gridData.push(obj3)
            })
          }
        })
      } else if (stopRange === 'area') {
        base.map(item => {
          const obj = { ...stopDeliveryList }
          obj.baseName = item.deptName
          obj.base = item.deptCode

          if (planType.length) {
            planType.forEach(item2 => {
              const obj2 = { ...obj }
              obj2.planType = item2.value
              obj2.planTypeName = item2.name

              if (brand.length) {
                brand.forEach(item3 => {
                  const obj3 = { ...obj2 }
                  obj3.brandName = item3.name
                  obj3.brand = item3.value
                  gridData.push(obj3)
                })
              } else {
                gridData.push(obj2)
              }
            })
          } else {
            brand.forEach(item3 => {
              const obj3 = { ...obj }
              obj3.brandName = item3.name
              obj3.brand = item3.value
              gridData.push(obj3)
            })
          }
          return item
        })
      } else if (stopRange === 'dealer') {
        dealer.map(item => {
          const obj = { ...stopDeliveryList }
          obj.dealerName = item.name_org1
          obj.dealerCode = item.partner

          if (planType.length) {
            planType.forEach(item2 => {
              const obj2 = { ...obj }
              obj2.planType = item2.value
              obj2.planTypeName = item2.name

              if (brand.length) {
                brand.forEach(item3 => {
                  const obj3 = { ...obj2 }
                  obj3.brandName = item3.name
                  obj3.brand = item3.value
                  gridData.push(obj3)
                })
              } else {
                gridData.push(obj2)
              }
            })
          } else {
            if (brand.length) {
              brand.forEach(item3 => {
                const obj3 = { ...obj }
                obj3.brandName = item3.name
                obj3.brand = item3.value
                gridData.push(obj3)
              })
            } else {
              gridData.push(obj)
            }
          }
          return item
        })
      }

      return gridData
    }
  }
}
</script>
<style lang="scss" scoped>
.form {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/components/DeliverySettings.vue